import React, { useState } from 'react';
import { Button } from 'antd';
import{addVisitLog, history} from 'libs';
// import { hasPermission } from "../libs";
import styles from './index.module.less';
import defaultPicture from './default-picture.png';
import cartStore from "pages/cart/store"

// 工具函数，需你实现
const toPrice6 = (price) => {
  // 保留两位小数
  return Number(price).toFixed(2);
};

const goDetail = (item)=>{
  addVisitLog({
      pageName: '产品详情页',
      fromPageUrl: history.location.pathname,
      pageUrl:`${window.location.origin}/goods/detail?id=${item.id}`,
      eventCode: "HomeProductImg",
      eventName: "首页产品图片",
      content: JSON.stringify(item),
  })
  window.open('/goods/detail?id=' + item.id,'_blank')
  }

// 加入购物车 - 添加防重复点击逻辑
const createBuyHandler = (loadingMap, setLoadingMap) => {
  return async (record = {}, isBuy = true) => {
    const key = `${record.id}-${isBuy}`;
    if (loadingMap[key]) return; // 正在加载中，阻止重复点击

    let eventCode = 'HomeProductRent';
    let eventName = '首页产品租赁';
    if (isBuy) {
      eventCode = 'HomeProductSale';
      eventName = '首页产品采购';
    }

    addVisitLog({
      pageName: eventName,
      fromPageUrl: window.referrerUrl,
      pageUrl: `${window.location.origin}${history.location.pathname}`,
      eventCode: eventCode,
      eventName: eventName,
    });

    // 设置加载状态
    setLoadingMap(prev => ({ ...prev, [key]: true }));

    try {
      await cartStore.addRecord(record.id, isBuy ? record.saleCatalog : record.leaseCatalog);
    } catch (error) {
      console.error('Add to cart failed:', error);
    } finally {
      // 清除加载状态
      setLoadingMap(prev => ({ ...prev, [key]: false }));
    }
  };
};


const ListTemplate = ({ skuList = [], previewUrl = '' }) => {
  // 使用对象存储每个按钮的加载状态，key 为 "商品id-操作类型"
  const [loadingMap, setLoadingMap] = useState({});
  const handleBuy = createBuyHandler(loadingMap, setLoadingMap);

  return (
    <div className={styles['list-wrapper']}>
    <div className={styles['special-content']}>
        <img src={previewUrl} className={styles['classify-bg']} alt="" />
    </div>
    {skuList.map((item, index) => (
      <div
        className={styles['list-content']}
        key={item.skuNo || index}
        onClick={() => goDetail(item)}
      >
        <div className={styles['goods-pic'] + ' font0'}>
          {item?.thumb ? (
            <img src={item.thumb} alt={item.name} />
          ) : (
            <img className={styles['default-picture']} src={defaultPicture} alt="" />
          )}
          <div className={styles['picture-shadow']}></div>
        </div>
        <div className={styles['goods-name']} title={item.name}>{item.name}</div>
        <div className={styles['goods-brand']} title={item.brand+' | '+item.factoryCode}>
        {item.brand}&nbsp;|&nbsp;{item.factoryCode}
          {/* <span>{item.brand}</span>
          <span className={styles['brand-line']}>|</span>
          <span>{item.factoryCode}</span> */}
        </div>
        <div className={styles['opera-button']}>
          {item['leaseAble'] ? (
            <div
              className={`${styles['opera-button-common']} ${styles['opera-button-primary']} ${loadingMap[`${item.id}-false`] ? styles['loading'] : ''}`}
              onClick={v => { v.stopPropagation(); handleBuy(item, false); }}
            >
              {loadingMap[`${item.id}-false`] ? '处理中...' : '租赁'}
            </div>
          ) : null}
          {item['saleAble'] ? (
            <div
              className={`${styles['opera-button-common']} ${styles['opera-button-theme']} ${loadingMap[`${item.id}-true`] ? styles['loading'] : ''}`}
              onClick={v => { v.stopPropagation(); handleBuy(item, true); }}
            >
              {loadingMap[`${item.id}-true`] ? '处理中...' : '采购'}
            </div>
          ) : null}
        </div>
      </div>
    ))}
    </div>
  );
};


export default ListTemplate;